import type { Artwork } from '../types';

/** 作品カード。artist / caption が空なら行ごと出さない。 */
export function renderCard(el: HTMLElement, a: Artwork): void {
  el.replaceChildren();
  const title = document.createElement('div');
  title.className = 'title';
  title.textContent = a.title;
  el.append(title);
  if (a.artist) {
    const artist = document.createElement('div');
    artist.className = 'artist';
    artist.textContent = a.artist;
    el.append(artist);
  }
  if (a.caption) {
    const caption = document.createElement('div');
    caption.className = 'caption';
    caption.textContent = a.caption;
    el.append(caption);
  }
  if (a.link_url) {
    const link = document.createElement('a');
    link.className = 'link';
    link.href = a.link_url;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    link.textContent = '作者ホームページ →';
    if (a.link_icon) {
      const icon = document.createElement('img');
      icon.className = 'link-icon';
      icon.src = a.link_icon;
      icon.alt = '';
      link.append(icon);
    }
    el.append(link);
  }
}
